import Reveal from "@/components/Reveal";
import { Instagram, ArrowUpRight } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/fiordipanna/";

export default function News({ items, t }) {
  return (
    <section id="news" data-testid="news-section" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51] mb-4">
              {t.news.over}
            </p>
            <h2 className="font-display tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#241C1A] leading-[1.1]">
              {t.news.title}
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="text-base text-[#6E625E] leading-relaxed">{t.news.follow}</p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="news-instagram-cta"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#1E1614] text-[#FAF7F2] px-6 py-3 text-sm font-medium hover:bg-[#C86D51] transition-colors duration-300"
            >
              <Instagram size={17} /> {t.news.followCta}
            </a>
          </div>
        </Reveal>

        <div className="mt-12 sm:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((n, i) => (
            <Reveal key={n.title} delay={i * 0.12}>
              <article
                data-testid={`news-card-${i}`}
                className="group h-full bg-white rounded-3xl overflow-hidden border border-[#241C1A]/10 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[box-shadow,transform] duration-300 flex flex-col"
              >
                <div className="overflow-hidden">
                  <img
                    src={n.image}
                    alt={n.title}
                    loading="lazy"
                    className="w-full aspect-[16/10] object-cover group-hover:scale-[1.05] transition-transform duration-700"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3">
                    <span className="font-accent text-[10px] uppercase tracking-[0.16em] bg-[#F3ECE0] text-[#241C1A] px-3 py-1.5 rounded-full">
                      {n.tag}
                    </span>
                    <span className="font-accent text-[10px] uppercase tracking-[0.16em] text-[#6E625E]">
                      {n.date}
                    </span>
                  </div>
                  <h3 className="font-display text-xl sm:text-2xl text-[#241C1A] tracking-tight mt-4">
                    {n.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#6E625E] flex-1">{n.text}</p>
                  {n.link_url && (
                    <a
                      href={n.link_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`news-link-${i}`}
                      className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#C86D51] hover:text-[#A84C32] transition-colors"
                    >
                      {t.news.more} <ArrowUpRight size={15} />
                    </a>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
